import { isWordChar } from './boundaries'
import type { TextRange } from './types'

/**
 * **Als Text gelassene Stellen wandern beim Tippen mit** (#234).
 *
 * Verglichen werden gemeinsamer Anfang und gemeinsames Ende beider Texte; dazwischen liegt, was sich
 * geändert hat. Stellen davor bleiben, Stellen dahinter rücken um die Längendifferenz. Wer IN einer
 * Stelle tippt oder löscht — auch direkt an ihr dran, solange es ein Buchstabe ist —, ändert das
 * Wort: Die Stelle fällt weg, und das neue Wort darf wieder erkannt werden.
 */
export function remapRanges(prevText: string, nextText: string, ranges: TextRange[]): TextRange[] {
  if (prevText === nextText) return ranges
  const { prefix, changedEnd, inserted, delta } = diffBounds(prevText, nextText)

  const result: TextRange[] = []
  for (const range of ranges) {
    const touchesStart = range.end === prefix && isWordChar(inserted[0])
    const touchesEnd = range.start === changedEnd && isWordChar(inserted[inserted.length - 1])
    const inside = range.start < changedEnd && range.end > prefix
    if (inside || touchesStart || touchesEnd) continue
    result.push(range.start >= changedEnd ? { start: range.start + delta, end: range.end + delta } : range)
  }
  return result
}

/** Gemeinsamer Anfang und gemeinsames Ende zweier Texte — dazwischen liegt die eine geänderte Strecke. */
export function diffBounds(prevText: string, nextText: string) {
  let prefix = 0
  const maxPrefix = Math.min(prevText.length, nextText.length)
  while (prefix < maxPrefix && prevText[prefix] === nextText[prefix]) prefix++

  let suffix = 0
  const maxSuffix = Math.min(prevText.length, nextText.length) - prefix
  while (
    suffix < maxSuffix
    && prevText[prevText.length - 1 - suffix] === nextText[nextText.length - 1 - suffix]
  ) suffix++

  return {
    prefix,
    /** Ende der geänderten Strecke im alten Text. */
    changedEnd: prevText.length - suffix,
    inserted: nextText.slice(prefix, nextText.length - suffix),
    delta: nextText.length - prevText.length,
  }
}
